import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=8fcbfefe&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=8fcbfefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcbfefe",
  null
  
)

export default component.exports